<template>
    <div>
        <v-row>
            <v-col md="6" sm="12" class="py-0">
                <div class="subtitle-2 mb-2">{{$t('veneerBSSection')}}</div>
                <v-select
                        dense
                        outlined
                        return-object
                        hide-details
                        :disabled="getCharacteristicAndValues('KTU_MM_FURNIEROBERFL_BS').values.length === 1"
                        :menu-props="{ offsetY: true }"
                        :items="getCharacteristicAndValues('KTU_MM_FURNIEROBERFL_BS').values" item-text="description"
                        :value="getRegisteredCharacteristicsValue('KTU_MM_FURNIEROBERFL_BS', doorLeafSurfaceContext).value"
                        @change="addCharacterisitc({ characteristic: getCharacteristicAndValues('KTU_MM_FURNIEROBERFL_BS'), valueDefinition: $event })">
                </v-select>
            </v-col>

            <v-col md="6" sm="12" class="py-0">
                <div class="subtitle-2 mb-2">{{$t('veneerGBSSection')}}</div>
                <v-select
                        dense
                        outlined
                        return-object
                        hide-details
                        :disabled="getCharacteristicAndValues('KTU_MM_FURNIEROBERFL_GBS').values.length === 1"
                        :menu-props="{ offsetY: true }"
                        :items="getCharacteristicAndValues('KTU_MM_FURNIEROBERFL_GBS').values" item-text="description"
                        :value="getRegisteredCharacteristicsValue('KTU_MM_FURNIEROBERFL_GBS', doorLeafSurfaceContext).value"
                        @change="addCharacterisitc({ characteristic: getCharacteristicAndValues('KTU_MM_FURNIEROBERFL_GBS'), valueDefinition: $event })">
                </v-select>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import {DoorConfiguration} from "../../../configurator/DoorConfiguration";

    export default {
        name: "Veneer",
        data: () => ({
            doorLeafSurfaceContext: DoorConfiguration.DoorLeafSurface,
        }),
        computed: {
            ...mapGetters('configuratorModule',['getRegisteredCharacteristicsValue']),
            ...mapGetters('doorLeafSurfaceModule', [ 'getCharacteristicAndValues' ]),
        },
        methods: {
            ...mapActions('doorLeafSurfaceModule', ['addCharacterisitc']),
        }
    }
</script>

<style scoped>

</style>